import { Drawer } from '@mui/material';
import React, { useCallback, useState } from 'react';
import CloseIcon from 'assets/png/close.svg';
import ResumeFilterForm from './ResumeFilterFrorm';
import { useForm } from 'react-hook-form';
import { ResumeFilterType } from 'types';
import { yupResolver } from '@hookform/resolvers/yup';
import { ResumeFilterSchema } from 'utils/ValidatorSchema';

interface ResumeFilterDrawerProps {
  isOpen: boolean;
  closeDrawer: () => void;
  callback: (filters: ResumeFilterType) => void;
  setParams?: any;
  listdataapi?: any;
  setcommonstate?: any;
  setpagetotal?: any;
  setLd?: any;
  Defaultparam?: any;
}

export const ResumeFilterDrawer: React.FC<ResumeFilterDrawerProps> = ({
  isOpen,
  closeDrawer,
  setParams,
  listdataapi,
  // setcommonstate,
  // setpagetotal,
  // setLd,
  Defaultparam,
}) => {
  const [key, setKey] = useState(0);
  const { control, handleSubmit, reset, formState, watch, trigger, setValue } =
    useForm<ResumeFilterType>({
      criteriaMode: 'all',
      defaultValues: {
        fromDate: undefined,
        toDate: undefined,
        interviewFrom: undefined,
        interviewTo: undefined,
        minExperience: undefined,
        maxExperience: undefined,
        currentStatus: undefined,
        branch: undefined,
        employee: undefined,
      },
      mode: 'onChange',
      reValidateMode: 'onChange',
      resolver: yupResolver(ResumeFilterSchema),
    });

  const closeSideDrawer = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);

  const resetFilters = useCallback(() => {
    setParams((prev: any) => ({
      ...prev,
      from: null,
      to: null,
      interviewFrom: null,
      interviewTo: null,
      employee: null,
      branch: null,
      minExperience: null,
      maxExperience: null,
      currentStatus: null,
    }));
    reset();
    listdataapi();
    setKey((prev) => prev + 1);
    setParams(Defaultparam);
  }, [reset]);

  const onSubmit = (data: any) => {
    if (
      data.fromDate ||
      data.toDate ||
      data.interviewFrom ||
      data.interviewTo ||
      data.employee ||
      data.branch ||
      data.minExperience ||
      data.maxExperience ||
      data.currentStatus
    ) {
      setParams((prev: any) => ({
        ...prev,
        from: data.fromDate ? data.fromDate : null,
        to: data.toDate ? data.toDate : null,
        interviewFrom: data.interviewFrom ? data.interviewFrom : null,
        interviewTo: data.interviewTo ? data.interviewTo : null,
        employee: data.employee ? data.employee : null,
        branch: data.branch ? data.branch : null,
        minExperience: data.minExperience ? data.minExperience : null,
        maxExperience: data.maxExperience ? data.maxExperience : null,
        currentStatus: data.currentStatus ? data.currentStatus : null,
      }));
    }
  };
  return (
    <Drawer
      anchor='right'
      open={isOpen}
      onClose={closeDrawer}
      sx={{
        flexShrink: 0,
        zIndex: 1200,
        ['& .MuiDrawer-paper']: {
          boxSizing: 'border-box',
          marginTop: '72px',
          width: '300px',
          padding: '30px',
          paddingTop: '0px',
        },
        ['& .MuiModal-backdrop ']: { backgroundColor: 'transparent' },
      }}>
      <header className='clientfilter-header'>
        <img
          src={CloseIcon}
          alt='closeicon'
          className='clientfilter-close-ico'
          onClick={closeSideDrawer}
        />
        <div className='heading'>Filters</div>
        <span
          className='clearall'
          style={{
            ...(!(
              watch('branch') ||
              watch('currentStatus') ||
              watch('employee') ||
              watch('fromDate') ||
              watch('interviewFrom') ||
              watch('interviewTo') ||
              watch('maxExperience') ||
              watch('minExperience') ||
              watch('toDate')
            )
              ? { opacity: '0.5', cursor: 'not-allowed' }
              : {}),
          }}
          onClick={() =>
            watch('branch') ||
            watch('currentStatus') ||
            watch('employee') ||
            watch('fromDate') ||
            watch('interviewFrom') ||
            watch('interviewTo') ||
            watch('maxExperience') ||
            watch('minExperience') ||
            watch('toDate')
              ? resetFilters()
              : ''
          }>
          Clear All
        </span>
      </header>
      <div className='clientfilter-divider'></div>
      <ResumeFilterForm
        setParams={setParams}
        key={key}
        control={control}
        handleSubmit={handleSubmit}
        formState={formState}
        onSubmit={onSubmit}
        watch={watch}
        trigger={trigger}
        setValue={setValue}
      />
    </Drawer>
  );
};
